import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { lazy, Suspense } from "react";
import Home from "./pages/home/home.page";
import Header from "./components/header/header.component";
import Footer from "./components/footer/footer.components";
import LinkedInLogin from "./components/login/LinkedInLogin";
import NotFoundPage from "./components/errorHandlers/notFoundPage.component";
import ScrollToTop from "./components/scrollToTop/scrollToTop.component";
import GoogleAnalytics from "./components/analytics/GoogleAnalytics";
import CanonicalUrl from "./components/seo/CanonicalUrl";

// Lazy loaded components
const AboutPage = lazy(() => import("./pages/about/about.page"));
const ClientsPage = lazy(() => import("./pages/clients/clients.page"));
const ContactPage = lazy(() => import("./pages/contact/contact.page"));
const CareersPage = lazy(() => import("./pages/careers/careers.page"));
const JobDetailPage = lazy(() => import("./pages/jobDetail/jobDetail.page"));
const OurTalentsPage = lazy(() => import("./pages/ourTalents/ourTalents.page"));
const WhatsNewPage = lazy(() => import("./pages/whatsnew/whatsnew.page"));
const TeamMemberDetails = lazy(
  () => import("./pages/team/teamMemberDetails.page"),
);

function App() {
  return (
    <Router>
      <GoogleAnalytics />
      <CanonicalUrl />
      <ScrollToTop />
      <header>
        <Header />
      </header>
      <main>
        <div>
          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "200px",
                  color: "#66fa93",
                }}
              >
                Loading...
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/clients" element={<Navigate to="/clients/1" />} />
              <Route path="/clients/:id" element={<ClientsPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/careers/job/:id" element={<JobDetailPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/ourtalents" element={<OurTalentsPage />} />
              <Route path="/blog" element={<WhatsNewPage />} />
              <Route path="/team/:id" element={<TeamMemberDetails />} />
              <Route path="/login" element={<LinkedInLogin />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </div>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
